/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Set_MainInputs */

const cs_gallery_set_main = /** @type {(inputs: Gallery_Set_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit jako hlavní`)
};

const en_gallery_set_main = /** @type {(inputs: Gallery_Set_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set as main`)
};

/**
* | output |
* | --- |
* | "Set as main" |
*
* @param {Gallery_Set_MainInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_set_main = /** @type {((inputs?: Gallery_Set_MainInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Set_MainInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_set_main(inputs)
	return cs_gallery_set_main(inputs)
});